import { createFileRoute } from "@tanstack/react-router";
import { SettingsBillingPage } from "@/pages/SettingsBillingPage";

export const Route = createFileRoute("/_app/settings/billing")({
  component: SettingsBillingPage
});
